/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import { Map as ImmutableMap, fromJS } from 'immutable';
import { openInpageModal } from 'EmailEditorUI/redux/actions/inpageActions';
import { CONTENT_DELETE_WARNING_MODAL } from 'EmailEditorUI/constants/InpageModals';
import { toLegacyData } from 'ContentUtils/helpers/DefaultModuleTransformHelpers';
import { CONTENT } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { uniqueId } from 'underscore';
import { getElementsCoordinatesFromSectionHelper, getSections, countElementsInSection, getShouldShowHubspotBranding, getSectionIndex } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getLayoutSettings, getEffectiveStyleSettings, getConvertedLinkStyleDefault, getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getSchemaForModule } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getIsCommentModeActive } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';
import { getIsWebVersionModule, getIsFooterModule, ensureImageWidthExists, getIsEmailProductModule } from 'EmailEditorUI/utils/moduleUtils';
import { transformModuleDataIntoMultiFieldData } from 'EmailEditorUI/utils/reducerUtils';
import { syncImageLinkData } from 'ContentUtils/helpers/ModuleDataSyncHelpers';
import { generateElementId, generateElement } from 'EmailEditorUI/utils/dragDropModuleUtils';
import { getSubject } from 'EmailEditorUI/redux/selectors/EditSelectors';
import { MODULE_TYPES, getModuleId } from 'EmailData/constants/DefaultModulesConstants';
import { getModuleType } from 'EmailData/constants/DefaultModulesConstants';
import { getElements, getElementIdByModulePath, hasWebVersionLinkModule, getWebVersionLinkModuleSpec, sectionHasWebversionLinkModule, getModulesThatAreNotInstantlyDeletable, getModuleSpec, hasFooterModule, getLegacyBuiltinModules, getFooterSectionIndex, getFooterId, getSectionWidgetsHelper, getMaxWidthForElement, getStyleSettingsDefaultForElement, getElementFromModuleId } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getSelectedId } from 'EmailEditorUI/redux/selectors/selected';
import { SELECT_INBOX_CONTENT, HIGHLIGHT_INBOX_SECTION, SELECT_SEND_OPTIONS } from 'EmailEditorUI/redux/actions/actionTypes';
import { getModuleDefaultsByType } from 'EmailEditorUI/utils/moduleDefaultsUtils';
import { getIsCMv2Module } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getDefaultFromSpec, isFieldARepeater } from 'EmailEditorUI/utils/fieldUtils';
import { CREATE_WEBVERSION_LINK, CREATE_MANDATORY_FOOTER, REMOVE_SECTION, REMOVE_ELEMENT, UPDATE_ELEMENT_DATA, UPDATE_MULTIPLE_FIELDS_ON_ELEMENT, SELECT_ELEMENT, ELEMENT_HIGHLIGHT, FORCE_ELEMENT_HIGHLIGHT, REMOVE_CURRENT_SELECTED_ITEM, SELECT_BUILTIN_WIDGET, SELECT_SECTION, DROP_LAYOUT_ON_SECTION, DROP_NEW_ELEMENT_ON_SECTION, APPEND_NEW_ELEMENT_TO_LAST_SECTION, DROP_NEW_ELEMENT_ON_ELEMENT, CLONE_SECTION, CLONE_ELEMENT, UPDATE_FIELD_PATH, CLICK_CATCHER_CLICKED, UPDATE_ELEMENT_BREAKPOINT_STYLES, REPLACE_ELEMENT } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { getRenderLanguage } from 'ContentEditorUI/redux/selectors/languageSelectors';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { getLayoutLoggingTypeForSection, getModuleLoggingType } from 'EmailEditorUI/utils/usageTracking';
import { getHasCustomFooters } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getIsTransactional } from 'EmailEditorUI/redux/selectors/subscriptionSelectors';
import { getAnyModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { focusIframeFromParent } from 'EmailEditorUI/utils/inpageUtils';
import Raven from 'raven-js';
import { getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { SMART_CAPABLE_WIDGET_TYPES } from 'ContentEditorUI/lib/widgetEdit/constants';
import { clearSelectedText } from 'ContentEditorUI/utils/helpers';
import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
import { getRowNameFromLayoutTreeBySectionIndex, getSectionIndexFromLayoutTree } from 'EmailEditorUI/redux/selectors/treeSelectors';
import { updateAiFeaturesForRemoveElements } from 'EmailEditorUI/redux/actions/aiFeaturesActions';
export const createNewElementAction = (moduleSpec, state, extra = {}) => {
  const elementId = extra.elementId || generateElementId();
  const userDefaults = extra.hasOwnProperty('userDefaults') ? extra.userDefaults : getModuleDefaultsByType(state, getModuleType(moduleSpec.moduleId), moduleSpec);
  return Object.assign({
    element: generateElement(moduleSpec, elementId, userDefaults),
    elementId
  }, extra);
};
export function selectSection(index, selected) {
  return dispatch => {
    clearSelectedText();
    dispatch({
      type: SELECT_SECTION,
      index,
      selected
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropLayoutOnSection({
  layoutSpec,
  dropPosition,
  forceDropOutsideBoxed,
  targetSectionIndex
}) {
  return (dispatch, getState) => {
    const state = getState();
    const isCommentModeActive = getIsCommentModeActive(state);
    dispatch({
      type: DROP_LAYOUT_ON_SECTION,
      layoutSpec,
      dropPosition,
      forceDropOutsideBoxed,
      targetSectionIndex,
      suppressSelection: isCommentModeActive
    });
  };
}
export function addNewLayoutBeforeFooter({
  layoutSpec
}) {
  return (dispatch, getState) => {
    const state = getState();
    const sectionIndex = getFooterSectionIndex(state) || getSections(state).size;
    dispatch(dropLayoutOnSection({
      layoutSpec,
      dropPosition: DropPosition.AFTER,
      targetSectionIndex: sectionIndex - 1,
      forceDropOutsideBoxed: false
    }));
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function dropNewElementOnSection({
  moduleSpec,
  dropPosition,
  forceDropOutsideBoxed,
  targetSectionIndex,
  elementId = generateElementId()
}) {
  return (dispatch, getState) => {
    const state = getState();
    const isCommentModeActive = getIsCommentModeActive(state);
    const isSingleColumnFullWidth = getIsSingleColumnFullWidth(state);
    dispatch(createNewElementAction(moduleSpec, state, {
      type: DROP_NEW_ELEMENT_ON_SECTION,
      elementId,
      dropPosition,
      forceDropOutsideBoxed,
      targetSectionIndex,
      suppressSelection: isCommentModeActive,
      isSingleColumnFullWidth
    }));
  };
}
export function appendNewElementToLastSection(moduleTypeOrSpec, fieldOverrides = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const isCommentModeActive = getIsCommentModeActive(state);
    let moduleSpec;
    if (typeof moduleTypeOrSpec === 'object') {
      moduleSpec = moduleTypeOrSpec;
    } else {
      const moduleId = getModuleId(moduleTypeOrSpec);
      moduleSpec = getModuleSpec(state, moduleId);
    }
    const userDefaults = getModuleDefaultsByType(state, getModuleType(moduleSpec.moduleId), moduleSpec).merge(fieldOverrides);
    dispatch(createNewElementAction(moduleSpec, state, {
      type: APPEND_NEW_ELEMENT_TO_LAST_SECTION,
      createNewSection: getSections(state).isEmpty(),
      dropPosition: DropPosition.AFTER,
      userDefaults,
      suppressSelection: isCommentModeActive
    }));
  };
}
export function dropNewElementOnElement({
  moduleSpec,
  targetElementId,
  dropPosition,
  elementId = generateElementId()
}) {
  return (dispatch, getState) => {
    const state = getState();
    const isCommentModeActive = getIsCommentModeActive(state);
    dispatch(createNewElementAction(moduleSpec, state, {
      type: DROP_NEW_ELEMENT_ON_ELEMENT,
      targetElementId,
      elementId,
      dropPosition,
      suppressSelection: isCommentModeActive
    }));
  };
}
export function addNewElementBeforeFooter({
  moduleSpec
}) {
  return (dispatch, getState) => {
    const state = getState();
    const footerId = getFooterId(state);
    if (footerId) {
      dispatch(dropNewElementOnElement({
        targetElementId: footerId,
        moduleSpec,
        dropPosition: DropPosition.BEFORE
      }));
    } else {
      dispatch(appendNewElementToLastSection(moduleSpec));
    }
  };
}
export function maybeAddWebVersionLinkModule() {
  return (dispatch, getState) => {
    const state = getState();
    const createNewSection = !getIsSingleColumnFullWidth(state);
    if (!hasWebVersionLinkModule(state)) {
      var _fromJS;
      const moduleSpec = getWebVersionLinkModuleSpec(state);
      const fontDefault = getDefaultFromSpec(moduleSpec, 'font');
      const styleSettings = getEffectiveStyleSettings(state);
      const styleSettingsDefaultLinkStyle = getConvertedLinkStyleDefault(state);
      const subject = getSubject(state);
      dispatch(createNewElementAction(moduleSpec, state, {
        type: CREATE_WEBVERSION_LINK,
        dropPosition: DropPosition.BEFORE,
        targetSectionIndex: 0,
        isBoxed: getLayoutSettings(state).get('boxed'),
        emailBackgroundColor: styleSettings.get('background_color'),
        language: getRenderLanguage(state),
        userDefaults: ImmutableMap({
          font: (_fromJS = fromJS(fontDefault)) === null || _fromJS === void 0 ? void 0 : _fromJS.merge(styleSettingsDefaultLinkStyle)
        }),
        createNewSection,
        subject
      }));
    }
  };
}
export const maybeCreateMandatoryFooter = () => (dispatch, getState) => {
  const state = getState();
  const moduleSpec = getModuleSpec(state, getModuleId(MODULE_TYPES.FOOTER));
  const createNewSection = !getIsSingleColumnFullWidth(state);
  if (!getIsTransactional(state) && !hasFooterModule(state)) {
    dispatch(createNewElementAction(moduleSpec, state, {
      type: CREATE_MANDATORY_FOOTER,
      userDefaults: null,
      dropPosition: DropPosition.AFTER,
      targetSectionIndex: getSections(state).size - 1,
      isBoxed: getLayoutSettings(state).get('boxed'),
      emailBackgroundColor: getEffectiveStyleSettings(state).get('background_color'),
      language: getRenderLanguage(state),
      createNewSection
    }));
  }
};

// This fixes a repeater initialisation. In this case the module doesn't have the key for this repeater field
// so we're still using the schema for rendering. when changing this field for the 1st time,
// we need to make sure the repeater fields are initialised as arrays first
// https://issues.hubspotcentral.com/browse/COSEMAIL-13424
export const maybeGetRequiredDefaultsForField = (key, element, spec) => {
  const prefix = key[0] === 'body' ? [] : ['body'];
  const keyWithPrefix = prefix.concat(key);
  if (!spec || keyWithPrefix.length <= 2) {
    return null;
  }
  const isUpdatedFieldAnIndex = typeof keyWithPrefix[keyWithPrefix.length - 1] === 'number';
  let maybeOccurrenceFieldName;
  let maybeOccurrenceFieldPath;
  if (isUpdatedFieldAnIndex) {
    maybeOccurrenceFieldName = keyWithPrefix[keyWithPrefix.length - 2];
    maybeOccurrenceFieldPath = keyWithPrefix.slice(0, keyWithPrefix.length - 1);
  } else {
    maybeOccurrenceFieldName = keyWithPrefix[1];
    maybeOccurrenceFieldPath = keyWithPrefix.slice(0, 2);
  }
  if (!element.getIn(keyWithPrefix) && !element.getIn(maybeOccurrenceFieldPath) && isFieldARepeater(spec, maybeOccurrenceFieldName)) {
    const defaultValue = getDefaultFromSpec(spec, maybeOccurrenceFieldName);
    if (defaultValue) {
      return {
        key: maybeOccurrenceFieldPath,
        value: defaultValue
      };
    }
  }
  return null;
};
export function shouldIgnoreUndoAction(element, elementData) {
  const isProductModuleUpdate = getIsEmailProductModule(element);
  const isCurrencyUpdate = elementData.key[0] === 'currency';
  const isInitialCurrencyUpdate = !element.getIn(['body', 'currency']);
  return isProductModuleUpdate && isCurrencyUpdate && isInitialCurrencyUpdate;
}
export function updateElementData(data, updatedModule) {
  return (dispatch, getState) => {
    const {
      id,
      elementData
    } = data;
    const state = getState();
    let refreshModuleBody = false;
    const element = getElements(state).get(id) || getAnyModuleById(state, id);
    if (!element) {
      Raven.captureException(new Error('Element is attempting to update even though it is deleted'), {
        elementId: id,
        extra: data,
        level: 'warning'
      });
      return;
    }
    const spec = getSchemaForModule(state, element);
    if (!spec) {
      Raven.captureException(new Error('Spec is missing for the module'), {
        elementId: id,
        extra: {
          moduleSchemas: state && state.moduleSchemas && state.moduleSchemas.all,
          builtinMapping: state && state.moduleSchemas && state.moduleSchemas.builtinMapping,
          element
        },
        level: 'error'
      });
      return;
    }
    const type = element.get('type');
    const path = spec.path;

    // Needed until Image/Logo modules are updated with new Link fields
    // https://git.hubteam.com/HubSpot/DesignManagerApi/pull/2343#issuecomment-1098422
    if (type === 'logo' || path === '@hubspot/logo' || path === '@hubspot/email_logo' || type === 'linked_image' || path === '@hubspot/linked_image' || path === '@hubspot/email_linked_image') {
      updatedModule = syncImageLinkData(element.toJS(), updatedModule, spec);
      refreshModuleBody = !!updatedModule;
    }
    if (!getIsCMv2Module(state, element.get('name') || element.get('id')) && !SMART_CAPABLE_WIDGET_TYPES.includes(type)) {
      updatedModule = toLegacyData(type, updatedModule, spec);
      refreshModuleBody = !!updatedModule;
    }

    // Set the default value for the element if unset by the user
    if (typeof elementData.value === 'undefined' || elementData.value === null || elementData.value === '') {
      const newValue = getStyleSettingsDefaultForElement(state, spec.moduleId, ...elementData.key);

      // Only set if we have a default set
      // (this allows fields that can be empty to continue being so)
      if (newValue) {
        updatedModule = fromJS(updatedModule).setIn(elementData.key, newValue).toJS();
        elementData.value = newValue;
      }
    }
    dispatch({
      type: UPDATE_ELEMENT_DATA,
      id,
      element,
      elementData,
      updatedModule,
      refreshModuleBody,
      requiredDefaultsFromSpec: maybeGetRequiredDefaultsForField(elementData.key, element, spec),
      undoData: {
        groupKey: id
      },
      maxWidth: getMaxWidthForElement(state, id),
      ignoreUndoAction: shouldIgnoreUndoAction(element, elementData)
    });
  };
}
export function updateElementBreakpointStyles({
  element,
  newStyles,
  breakpointName,
  isEditingForAllDevices = true
}) {
  return {
    type: UPDATE_ELEMENT_BREAKPOINT_STYLES,
    element,
    breakpointName,
    isEditingForAllDevices,
    newStyles,
    undoData: {
      groupKey: element.get('id')
    }
  };
}
export function updateImageElementData(data, updatedModule) {
  return (dispatch, getState) => {
    const {
      id,
      elementData
    } = data;
    const state = getState();
    if (elementData && elementData.value && getIsDragDropEmail(state)) {
      elementData.value = ensureImageWidthExists(elementData.value, getMaxWidthForElement(state, id));
    }
    const updateElementDataFn = updateElementData(data, updatedModule);
    return updateElementDataFn(dispatch, getState);
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const updateMultipleElementFields = data => (dispatch, getState) => {
  const {
    id
  } = data;
  const state = getState();
  const element = getElements(state).get(id) || getAnyModuleById(state, id);
  const elementMultipleData = Array.isArray(data.elementMultipleData) ? data.elementMultipleData : transformModuleDataIntoMultiFieldData(data.elementMultipleData);
  dispatch({
    type: UPDATE_MULTIPLE_FIELDS_ON_ELEMENT,
    id,
    element,
    elementMultipleData,
    maxWidth: getMaxWidthForElement(state, id)
  });
};

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const removeSection = (index, withTracking = false) => (dispatch, getState) => {
  const state = getState();
  const elements = getElements(state);
  const section = getSections(state).get(index);
  const elementIds = section.get('columns').flatMap(c => c.get('widgets')).filter(id => {
    if (!elements.has(id)) {
      Raven.captureException(new Error(`Element with id ${id} still exists in section but not in elements`));
      return false;
    }
    return true;
  });
  const warningModules = getModulesThatAreNotInstantlyDeletable(state, elementIds.toJS());
  if (warningModules.length > 0) {
    dispatch(openInpageModal(CONTENT_DELETE_WARNING_MODAL, {
      modules: warningModules,
      sectionIndex: index
    }));
  } else {
    if (withTracking) {
      UsageTracker.trackEditorInteraction({
        action: 'Modify Layout Action',
        event: 'delete-section',
        'module-type': getLayoutLoggingTypeForSection(section),
        breakpointName: getActiveBreakpointName(state)
      });
    }
    const footerIsDeleted = elementIds.some(id => getIsFooterModule(elements.get(id)) && getModuleSpec(state, elements.get(id)));
    if (footerIsDeleted && !getHasCustomFooters(state)) {
      dispatch(maybeCreateMandatoryFooter());
    }
    const isLastSectionBeforeBranding = getShouldShowHubspotBranding(state) && index === getSections(state).size - 1;
    dispatch(updateAiFeaturesForRemoveElements({
      elementIds
    }));
    return dispatch({
      type: REMOVE_SECTION,
      index,
      elementIds,
      isLastSectionBeforeBranding
    });
  }
  return () => false;
};

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function cloneSection(index) {
  return (dispatch, getState) => {
    const section = getSections(getState()).get(index);
    const widgetIds = getSectionWidgetsHelper(section);
    const widgetIdMap = {};
    widgetIds.forEach(id => {
      widgetIdMap[id] = uniqueId(`module_${Date.now()}`);
    });
    dispatch({
      type: CLONE_SECTION,
      index,
      widgetIdMap,
      targetSectionIndex: index
    });
  };
}
// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const removeElement = (data, withTracking = false) => (dispatch, getState) => {
  const state = getState();
  const elements = getElements(state);
  const {
    id,
    index,
    columnIndex,
    sectionIndex
  } = data;
  const element = elements.get(id);
  const section = getSections(state).get(sectionIndex);
  const isSingleColumnFullWidth = getIsSingleColumnFullWidth(state);
  dispatch(updateAiFeaturesForRemoveElements({
    elementIds: [id]
  }));
  if (!isSingleColumnFullWidth && countElementsInSection(section) === 1) {
    return dispatch(removeSection(sectionIndex));
  }
  const warningModules = getModulesThatAreNotInstantlyDeletable(state, [id]);
  if (warningModules.length > 0) {
    return dispatch(openInpageModal(CONTENT_DELETE_WARNING_MODAL, {
      modules: warningModules
    }));
  }
  if (withTracking) {
    UsageTracker.trackEditorInteraction({
      action: 'Modify Layout Action',
      event: 'delete-module',
      'module-type': getModuleLoggingType(element.get('module_id')),
      breakpointName: getActiveBreakpointName(state)
    });
  }
  if (getIsFooterModule(element) && !getHasCustomFooters(state)) {
    dispatch(maybeCreateMandatoryFooter());
  }
  return dispatch({
    type: REMOVE_ELEMENT,
    id,
    index,
    columnIndex,
    sectionIndex,
    canMergeColumns: !isSingleColumnFullWidth
  });
};

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function cloneElement(data) {
  const {
    id,
    index,
    columnIndex,
    sectionIndex
  } = data;
  const newWidgetId = generateElementId();
  return {
    type: CLONE_ELEMENT,
    id,
    index,
    columnIndex,
    sectionIndex,
    newWidgetId
  };
}
export function removeWebVersionLinkModule() {
  return (dispatch, getState) => {
    const state = getState();
    const elements = getElements(state);
    getSections(state).forEach((s, sectionIndex) => {
      if (sectionHasWebversionLinkModule(state, s)) {
        const elementsInSection = getElementsCoordinatesFromSectionHelper(s);
        if (elementsInSection.length === 1) {
          // section contains only 1 web version element, remove the whole section
          dispatch(removeSection(sectionIndex));
        } else {
          // search and remove element by element

          elementsInSection.forEach(elementInfo => {
            if (getIsWebVersionModule(elements.get(elementInfo.id))) {
              dispatch(removeElement(Object.assign({
                sectionIndex
              }, elementInfo)));
            }
          });
        }
      }
    });
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const removeCurrentSelectedItem = () => ({
  type: REMOVE_CURRENT_SELECTED_ITEM
});
// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const selectBuiltinWidget = widgetType => ({
  type: SELECT_BUILTIN_WIDGET,
  builtinType: widgetType
});

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const selectInboxContent = () => ({
  type: SELECT_INBOX_CONTENT
});

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export const selectSendOptions = () => ({
  type: SELECT_SEND_OPTIONS
});

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function selectElement(id, {
  selected = true,
  showErrorsImmediately = false,
  fieldPath = null,
  selectedByApp = false,
  tabId = CONTENT
} = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const elements = getElements(state);
    const isCustom = getIsCustomEmail(state);
    const selectedId = getSelectedId(state);
    clearSelectedText();
    // remove the current selection if user clicks on the selected item
    if (selectedId && selectedId === id) {
      dispatch(removeCurrentSelectedItem());
    } else if (isCustom && getLegacyBuiltinModules(state).has(id)) {
      focusIframeFromParent();
      dispatch(selectBuiltinWidget(id));
    } else if (!selected || elements.has(id) || isCustom && getAnyModuleById(state, id)) {
      if (isCustom) {
        focusIframeFromParent();
      }
      dispatch({
        type: SELECT_ELEMENT,
        id,
        selected,
        fieldPath,
        selectedByApp,
        showErrorsImmediately,
        tabId
      });
    }
  };
}
export function selectFooterModule() {
  return (dispatch, getState) => {
    const state = getState();
    const footerId = getModuleId(MODULE_TYPES.FOOTER);
    const element = getElementFromModuleId(state, footerId);
    dispatch(selectElement(element.get('id'), {
      selected: true
    }));
  };
}
export function selectElementByModulePath(modulePath, {
  selectedByApp = false
} = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const elementId = getElementIdByModulePath(state, modulePath);
    if (elementId) {
      dispatch(selectElement(elementId, {
        selectedByApp
      }));
    }
  };
}
export const getIdUsedToHighlight = ({
  id,
  state,
  source,
  isSection
}) => {
  let idToUse = id;
  if (isSection) {
    if (source === 'parent') {
      const indexInTree = getSectionIndexFromLayoutTree(id)(state);
      const section = getSections(state).get(indexInTree);
      idToUse = section.get('id');
    } else if (source === 'iframe') {
      const sectionIndex = getSectionIndex(state, id);
      const nameInTree = getRowNameFromLayoutTreeBySectionIndex(sectionIndex)(state);
      idToUse = nameInTree;
    }
  }
  return idToUse;
};

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
// this function is used to arbitrary highlight an element and needs a manual reset to remove the highlight
export function highlightElement(id = null, source = 'parent', isSection = false) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedId = getSelectedId(state);
    const idToUse = getIdUsedToHighlight({
      state,
      isSection,
      source,
      id
    });
    if (!selectedId || !id || selectedId === id) {
      dispatch({
        type: ELEMENT_HIGHLIGHT,
        id: idToUse
      });
    }
  };
}
export function highlightInboxSection(isHovered = false) {
  return {
    type: HIGHLIGHT_INBOX_SECTION,
    isHovered
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
// this function is used to arbitrary highlight an element and needs a manual reset to remove the highlight
export function forceHighlightElement(id = null) {
  return {
    type: FORCE_ELEMENT_HIGHLIGHT,
    id
  };
}

// When migrating to ts - action is typed in EmailEditorUI/redux/actions/types/layoutActions
export function updateFieldPath(fieldKey = null) {
  return {
    type: UPDATE_FIELD_PATH,
    fieldPath: fieldKey
  };
}
export function clickCatcherClicked() {
  return {
    type: CLICK_CATCHER_CLICKED
  };
}
export function resetModuleToDefault(elementId) {
  return (dispatch, getState) => {
    const state = getState();
    const element = getElements(state).get(elementId);
    const moduleSpec = getModuleSpec(state, element);
    dispatch(createNewElementAction(moduleSpec, state, {
      type: REPLACE_ELEMENT,
      elementId,
      suppressSelection: false
    }));
  };
}